// extracted by mini-css-extract-plugin
export default {"mapping":"styles_mapping__hbkEE","saveSection":"styles_saveSection__EjRov"};